import { render, staticRenderFns } from "./AppRealTimeReportCards.vue?vue&type=template&id=934942f4&scoped=true&"
import script from "./AppRealTimeReportCards.vue?vue&type=script&lang=js&"
export * from "./AppRealTimeReportCards.vue?vue&type=script&lang=js&"
import style0 from "./AppRealTimeReportCards.vue?vue&type=style&index=0&id=934942f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934942f4",
  null
  
)

export default component.exports